import { TabsProps } from 'antd';

export const getTabs = (isDisabled: boolean): TabsProps['items'] => {
    return [
        { label: 'Посетители', key: 'visitors', disabled: false },
        { label: 'Заказы', key: 'orders', disabled: isDisabled },
        { label: 'Массовые рассылки', key: 'mass-broadcasts', disabled: false },
        {
            label: 'Триггерные рассылки',
            key: 'auto-broadcasts',
            disabled: false,
        },
        { label: 'Выгрузка', key: 'exports', disabled: false },
    ];
};
